import styled, { keyframes } from 'styled-components';

/* Floating Animation */
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

/* Container */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 120px 0;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: -10%;
    width: 60%;
    height: 60%;
    background: radial-gradient(circle, rgba(133, 76, 230, 0.12) 0%, transparent 60%);
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -10%;
    right: -10%;
    width: 60%;
    height: 70%;
    background: radial-gradient(circle, rgba(0, 210, 255, 0.08) 0%, transparent 60%);
    z-index: -1;
  }
`;

/* Wrapper */
export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1350px;
  padding: 0 40px;
  gap: 12px;
`;

/* Title */
export const Title = styled.div`
  font-size: 56px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  color: #FFFFFF;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 38px;
  }
`;

/* Description */
export const Desc = styled.div`
  font-size: 19px;
  text-align: center;
  max-width: 750px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 70px;
  line-height: 1.6;
`;

/* Grid */
export const DocGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

/* Icon */
export const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: ${({ color = '#854CE6' }) => color + '22'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color = '#854CE6' }) => color};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: ${({ color = '#854CE6' }) => color};
    filter: blur(20px);
    opacity: 0.5;
    z-index: -1;
  }
`;

/* Card */
export const DocCard = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.3);
  border-radius: 28px;
  padding: 45px;
  cursor: pointer;
  transition: all 0.4s ease;
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, ${({ color = '#854CE6' }) => color + '15'} 0%, transparent 50%);
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-12px);
    border-color: ${({ color = '#854CE6' }) => color + '60'};
    background: rgba(255, 255, 255, 0.04);
    box-shadow: 0 25px 50px -10px ${({ color = '#854CE6' }) => color + '15'};
  }
`;

/* Tag */
export const DocType = styled.span`
  font-size: 10px;
  font-weight: 800;
  padding: 6px 12px;
  background: ${({ color = '#854CE6' }) => color + '15'};
  color: ${({ color = '#854CE6' }) => color};
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.15em;
`;

/* Title */
export const DocTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
`;

/* Description */
export const DocDesc = styled.p`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.7;
  flex-grow: 1;
  margin: 0;
`;

/* Button (FIXED for ESLint) */
export const ActionButton = styled.a.attrs({
  href: '#',
})`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: ${({ color = '#854CE6' }) => color};
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    gap: 14px;
    filter: brightness(1.2);
  }
`;

/* RESPONSIBILITIES SECTION */

export const RespContainer = styled.div`
  width: 100%;
  margin-top: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
`;

export const RespWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  gap: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const RespItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const BubbleIcon = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color = '#854CE6' }) => color};
  box-shadow: 0 15px 35px -5px rgba(0, 0, 0, 0.4);
  animation: ${float} 6s ease-in-out infinite;
  animation-delay: ${({ delay = '0s' }) => delay};
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    background: ${({ color = '#854CE6' }) => color};
    filter: blur(25px);
    opacity: 0.4;
    z-index: -1;
  }

  &:hover {
    border-color: ${({ color = '#854CE6' }) => color};
    transform: scale(1.1);
  }
`;

export const RespLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #FFFFFF;
  opacity: 0.9;
`;